<div #gridContainer class="grid-container">
  <gridster [options]="options">
    <gridster-item *ngFor="let widget of dashboard.widgetViewConfigurations;let index = index"
                   [item]="dashboard.dashboardDesign?.widgetSizeConfiguration ?
                   dashboard.dashboardDesign?.widgetSizeConfiguration[widget.identification] ||  { id: widget.identification, cols: 4,rows: 10,y: 0,x: 0} : { id: widget.identification, cols: 4,rows: 10,y: 0,x: 0}">
      <app-widget-container [widget]="widget"
                            [dashboard]="dashboard"
                            [dateRange]="dateRange"
                            [programTypes]="programTypes"
                            [userBranches]="userBranches"
                            [userTeams]="userTeams"
                            [userBranchesIntersectionTeamMap]="userBranchesIntersectionTeamMap"
                            [datasourceConfiguration]="datasourceConfigurationsMap[widget.datasource]"
                            [isHideActions]="currentUser.id !== dashboard.ownerId"
                            (deleteWidgetEvent)="deleteWidgetEvent.emit({index, widget})"
                            (editWidgetEvent)="editWidgetEvent.emit(widget)">

      </app-widget-container>
    </gridster-item>

  </gridster>
</div>


